<script setup lang="ts">
/**
 * This component provides a selectable list of terminals. It is used in the header
 * and requries a current terminal to be set.
 */

import { ref, watch } from "vue";
import { useTerminalsStore } from "@/stores/terminals";
import { storeToRefs } from "pinia";
import { useTerminals } from "@/composables/terminals";

const terminalsStore = useTerminalsStore();
const { goToTerminal } = useTerminals();

const { activeTerminal, terminalsList } = storeToRefs(terminalsStore);

if (activeTerminal.value == null) {
  throw "Terminal must be set for component to operate";
}

const selectedTerminal = ref({
  value: activeTerminal.value.id,
  title: activeTerminal.value.name,
});
const terminalsSelectItems = ref(
  terminalsList.value.map((terminal) => ({
    value: terminal.id,
    title: terminal.name,
  })),
);

watch(selectedTerminal, (newSelectedTerminal) => {
  goToTerminal(newSelectedTerminal.value);
});
</script>

<template>
  <v-container :elevation="2">
    <v-row class="pt-6 pb-1" no-gutters>
      <v-col cols="8">
        <v-select
          v-model="selectedTerminal"
          bg-color="rgba(255, 255, 255, 0.2)"
          item-color="orange lighten-1"
          :items="terminalsSelectItems"
          style="font-size: 16px"
          rounded="rounded-lg"
          :menu-props="{ openOnHover: true, openDelay: 1 }"
          variant="solo"
          :return-object="true"
          base-color="orange lighten-1"
          auto
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
:deep(.v-icon),
:deep(.v-select__selection),
:deep(.v-select__selection--comma),
:deep(.v-select.v-text-field) input {
  color: white !important;
}
</style>
